import React, { useState } from "react";
import styles from "./CompleteProfileForm.module.css";
import logo from "../../assets/Gaffer Transparent Logo1.png";
import { updateProfilePost } from "../../api/handleapi";
import Loader from "../../components/loader/Loader";
import swal from "sweetalert";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

const CompleteProfileForm = ({ userData, onComplete, onSkip }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: userData?.name?.split(" ")[0] || "",
    lastName: userData?.name?.split(" ").slice(1).join(" ") || "",
    dob: null,
  });

  const onUpdateField = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onUpdateDob = (date) => {
    setForm({ ...form, dob: date });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const bodyFormData = new FormData();
    bodyFormData.append("FirstName", form.firstName);
    bodyFormData.append("LastName", form.lastName);
    if (form.dob) {
      bodyFormData.append("DOB", form.dob.format("YYYY-MM-DD"));
    }

    try {
      const response = await updateProfilePost(bodyFormData);
      if (response.status === 200) {
        setLoading(false);
        swal("Success", "Profile updated successfully", "success").then(() => {
          onComplete();
        });
      }
    } catch (error) {
      setLoading(false);
      swal("Error", "Could not update profile", "error");
    }
  };

  return (
    <div className={styles.form}>
      <img className={styles.relogo} src={logo} alt="logo" />
      <h5 className={styles.title}><b>Complete Your Profile</b></h5>
      
      <div className={styles.formGroup}>
        <input
          className={styles.formField}
          type="text"
          name="firstName"
          placeholder="First Name"
          value={form.firstName}
          onChange={onUpdateField}
        />
      </div>

      <div className={styles.formGroup}>
        <input
          className={styles.formField}
          type="text"
          name="lastName"
          placeholder="Last Name"
          value={form.lastName}
          onChange={onUpdateField}
        />
      </div>

      <div className={styles.formGroup}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <DatePicker
              label="Date of Birth"
              value={form.dob}
              onChange={onUpdateDob}
              disableFuture
              sx={{ width: "100%" }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>

      <button className={styles.formSubmitBtn} onClick={onSubmit}>
        Save and Continue
      </button>
      
      <button className={styles.skipBtn} onClick={onSkip}>
        Maybe Later (Skip)
      </button>

      {loading && <Loader />}
    </div>
  );
};

export default CompleteProfileForm;
